import Vue from "vue";
import axios from "axios";
import moment from "moment";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";
import "../../filters";

export default {
  name: "agreements",
  components: {
    DataGridComp: require("../../customcontrols/datagrid.vue").default,
    datetime: Datetime,
    DateTime,
    reportsComp: require("../../common/reports/reports.vue").default,
  },
  props: ["dataObj"],
  data: function () {
    return {
      settings: {},
      filterObj: [],
      statusSelected: [],
      statusSelectedDefault: [],

      filters: {
        agreementStatus: -1,
        agreementType: null,
        consumerType: null,
        customerKey: "",
        startDate: null,
        endDate: null,
        excludeDeleted: true,
      },
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      noDataFound: false,
      agreements: [],
      agreementsCols: [],
      keyColumn: "keyCol",
      bShowInstallments: false,
      installmentsDtl: {},
      showReportsDialog: false,
      generalReports: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.fillAgreementsCols();
        this.getSettings();
        this.getGeneralReports();
      });
    },
    getSettings() {
      axios
        .get("/CustomerAgreement/GetSettings")
        .then((response) => {
          this.settings = response.data;

          this.filters.agreementStatus =
            this.settings.agreementStatuses.length == 0
              ? -1
              : this.settings.agreementStatuses[0].id;
          console.log(response);
          //this.fillFiltersObj();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getAgreements() {
      let parameters = {
        status: this.filters.agreementStatus,
        generated: this.filters.startDate,
        closed: this.filters.endDate,
        filter: this.filters.customerKey,
        AgreementTypeId: this.filters.agreementType,
        pageIndex: this.options.page,
        pageSize: this.options.pageSize,
        excludeDeleted: this.filters.excludeDeleted,
      };

      axios
        .post("/CustomerAgreement/GetCustomerAgreements", parameters)
        .then((response) => {
          console.log(response);

          response["completionDate"] = response["lastInstallmentDate"];

          for (var i = 0; i < response.data.items.length; i++) {
            response.data.items[i].keyCol =
              response.data.items[i].account +
              "_" +
              response.data.items[i].agreemNo;
            response.data.items[i].displayAgreemNo =
              response.data.items[i].agreemNo * -1;
          }

          this.agreements = response.data.items;
          this.totalRow = response.data.totalCount;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    clearFilters() {
      this.filters = {
        agreementStatus: -1,
        agreementType: null,
        consumerType: null,
        customerKey: "",
        startDate: null,
        endDate: null,
      };
    },
    onSelectAgreement(info) {
      if (info.rowIndex < 0) return;

      var agreem = this.agreements[info.rowIndex];
      console.log(agreem);

      var route = `/${
        agreem.status === 3 ? "createAgreement" : "agreementDetails"
      }/${agreem.account}/${agreem.agreemNo}`;
      this.$router.push(route);
    },
    onCellClick(info) {
      console.log(info);
    },
    pageChanging(page, pageSize, sort, sortOrder) {
      console.log(page);
      console.log(pageSize);
      console.log(sort);
      console.log(sortOrder);
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getAgreements();
    },
    fillAgreementsCols() {
      //this.agreementsCols.push({ dataField: 'keyCol', name: 'keyCol', caption: this.$t('customerAgreements.installments'), alignment: 'center', type: 'temp', tempName: 'installmentBtn' });
      this.agreementsCols.push({
        dataField: "displayAgreemNo",
        caption: this.$t("customerAgreements.agreemNo"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "billingGroup",
        caption: this.$t("activities.billingGroup"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "account",
        caption: this.$t("activities.account"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "name",
        caption: this.$t("activities.surname"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "statusDisplay",
        caption: this.$t("activities.agreementStatus"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "agreementAmount",
        caption: this.$t("customerAgreements.agreementAmount"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "installmentCount",
        caption: this.$t("customerAgreements.noOfinstallments"),
        alignment: "center",
      });
      this.agreementsCols.push({
        dataField: "installmentAmount",
        caption: this.$t("customerAgreements.installmentAmount"),
        alignment: "center",
      });
    },
    getCellClass(data) {},
    showInstallments(data) {
      console.log(data);

      axios
        .post(
          "/CustomerAgreement/GetCustomerAgreementInstallmentsAndBalance?account=" +
            data.account +
            "&agreemNo=" +
            data.agreemNo +
            "&pageIndex=1&pageSize=1000"
        )
        .then((response) => {
          console.log(response);
          this.installmentsDtl = response.data;

          this.installmentsDtl.totalAmount = this.installmentsDtl.items
            .reduce((a, b) => {
              return a + b.amount;
            }, 0)
            .toFixed(2);
          this.installmentsDtl.totalCount = this.installmentsDtl.items.length;
          this.installmentsDtl.totalIssudAmount = this.installmentsDtl.items
            .filter((a) => a.charged)
            .reduce((a, b) => {
              return a + b.amount;
            }, 0)
            .toFixed(2);
          this.installmentsDtl.totalIssudCount =
            this.installmentsDtl.items.filter((a) => a.charged).length;
          this.installmentsDtl.totalRestAmount =
            this.installmentsDtl.totalAmount -
            this.installmentsDtl.totalIssudAmount;
          this.installmentsDtl.totalRestCount =
            this.installmentsDtl.totalCount -
            this.installmentsDtl.totalIssudCount;

          this.bShowInstallments = true;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    createAgreement() {
      //window.open('/createAgreement/', '_blank');
      this.$router.push({ path: "/createAgreement" });
    },
    getGeneralReports() {
      axios
        .get("/CustomerAgreement/GetGeneralReports")
        .then((response) => {
          if (response.status == 200) {
            this.generalReports = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    printGeneralReport(reportId) {
      axios
        .post("/CustomerAgreement/CreateGeneralReport?reportId=" + reportId)
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, "_blank");
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
        );
    },
  },
};
